import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirm) {
      setError('Οι κωδικοί δεν ταιριάζουν');
      return;
    }
    if (password.length < 6) {
      setError('Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setSuccess(true);
      setTimeout(() => navigate('/login', { replace: true }), 3000);
    } catch (err) {
      setError(err.response?.data?.detail || 'Σφάλμα επαναφοράς κωδικού');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center px-4">
        <div className="text-center">
          <p className="text-red-400 text-sm font-light">Μη έγκυρος σύνδεσμος επαναφοράς.</p>
          <button onClick={() => navigate('/login')} className="mt-4 text-gray-400 text-sm underline">
            Επιστροφή στη σύνδεση
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="w-full max-w-sm">

        {/* Logo */}
        <div className="flex justify-center mb-10">
          <img src="/dimakas-logo.png" alt="DIMAKAS" style={{ maxWidth: '220px', height: 'auto' }} />
        </div>

        <h2 className="text-white text-sm font-light tracking-widest text-center mb-8 uppercase">
          Νέος Κωδικός
        </h2>

        {success ? (
          <div className="text-center space-y-4">
            <div className="px-4 py-3 bg-green-500/10 border border-green-500/30 text-green-400 text-sm font-light" data-testid="reset-success">
              Ο κωδικός αλλάχθηκε επιτυχώς! Ανακατεύθυνση...
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="reset-password-form">
            {error && (
              <div className="px-4 py-3 bg-red-500/10 border border-red-500/30 text-red-400 text-sm font-light" data-testid="reset-error">
                {error}
              </div>
            )}
            <input
              type="password"
              placeholder="Νέος κωδικός (τουλάχιστον 6 χαρακτήρες)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-white/5 border border-white/15 text-white placeholder:text-gray-600 px-4 py-3 text-sm font-light focus:outline-none focus:border-white/40 transition-colors"
              data-testid="new-password-input"
            />
            <input
              type="password"
              placeholder="Επιβεβαίωση νέου κωδικού"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              className="w-full bg-white/5 border border-white/15 text-white placeholder:text-gray-600 px-4 py-3 text-sm font-light focus:outline-none focus:border-white/40 transition-colors"
              data-testid="confirm-new-password-input"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-white text-black py-3.5 text-sm font-light tracking-widest hover:bg-gray-100 transition-colors disabled:opacity-50"
              data-testid="reset-submit-btn"
            >
              {loading ? 'ΑΠΟΘΗΚΕΥΣΗ...' : 'ΑΠΟΘΗΚΕΥΣΗ ΚΩΔΙΚΟΥ'}
            </button>
          </form>
        )}

        <div className="mt-6 text-center">
          <button
            onClick={() => navigate('/login')}
            className="text-gray-500 text-xs font-light tracking-widest hover:text-gray-300 transition-colors"
          >
            ΕΠΙΣΤΡΟΦΗ ΣΤΗ ΣΥΝΔΕΣΗ
          </button>
        </div>
      </div>
    </div>
  );
}
